import React, { useMemo } from 'react'
import { DSIHtmlProps } from './types'
import sanitize from 'sanitize-html'

export const DSIHtml = ({ children, as: Tag = 'div', ...props }: DSIHtmlProps) => {
  const __html = useMemo(() => children && sanitize(children), [children])
  if (!__html) return null
  return <Tag {...props} dangerouslySetInnerHTML={{ __html }} />
}
